const SORTABLE_PIPELINE_FIELDS = {
  name: 'name',
  writekey: 'writekey',
  cluster: 'cluster',
  integrations: 'integrations',
};

export default SORTABLE_PIPELINE_FIELDS;
